module.exports = __webpack_public_path__ + "img/rooms31.6757ad2c.png";